import type { ComponentPropsWithoutRef } from 'react';

import { BASE_PATH } from '@/constants/config';

type SocialIconName = 'facebook' | 'google' | 'linkedin' | 'outlook';

type SocialIconProps = Omit<ComponentPropsWithoutRef<'svg'>, 'children'> & {
  name: SocialIconName;
};

export function SocialIcon({ name, ...props }: SocialIconProps) {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24" {...props}>
      <use href={`${BASE_PATH}/assets/social-icons.svg#social-${name}`} />
    </svg>
  );
}
